import React, { useState } from "react";
import {
  Button,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  HStack,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  CreateToastFnReturn,
  Checkbox,
  Text,
} from "@chakra-ui/react";
import { Link } from "@chakra-ui/next-js";

import TermsPage from "@/app/(landing)/terms/page";
import PrivacyPage from "@/app/(landing)/privacy/page";

export function TermsAndConditionsErrorToast(toast: CreateToastFnReturn) {
  return toast({
    status: "error",
    title: "Terms & Conditions",
    description: "Please agree to the Terms & Conditions",
  });
}
export function TermsAndConditionsModal({
  onTermsAcceptedChanged,
  showOnlyTermsAndConditions,
}: {
  onTermsAcceptedChanged: (termsAccepted: boolean) => void;
  showOnlyTermsAndConditions?: boolean;
}) {
  const [isTermsModalOpen, setTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setPrivacyModalOpen] = useState(false);

  const openTermsModal = () => setTermsModalOpen(true);
  const closeTermsModal = () => setTermsModalOpen(false);

  const openPrivacyModal = () => setPrivacyModalOpen(true);
  const closePrivacyModal = () => setPrivacyModalOpen(false);
  const [terms, setTerms] = useState(false);

  const fontWeight = showOnlyTermsAndConditions ? undefined : "500";
  return (
    <>
      <VStack gap="24px" layerStyle="responsive" alignItems="center">
        <VStack>
          {!showOnlyTermsAndConditions && (
            <Checkbox
              isChecked={terms}
              onChange={(ev) => {
                onTermsAcceptedChanged(ev.target.checked);
                return setTerms(ev.target.checked);
              }}
            >
              Click to agree to our{" "}
            </Checkbox>
          )}
          <HStack>
            <Link
              href="#"
              as="button"
              onClick={openTermsModal}
              fontWeight={fontWeight}
            >
              Terms & Conditions
            </Link>{" "}
            {!showOnlyTermsAndConditions && <p>and</p>}
            <Link
              href="#"
              as="button"
              onClick={openPrivacyModal}
              fontWeight={fontWeight}
            >
              Privacy Policy
            </Link>
          </HStack>
        </VStack>
      </VStack>
      {/* Terms & Conditions Modal */}
      <Modal
        isOpen={isTermsModalOpen}
        onClose={closeTermsModal}
        isCentered
        size="xxl"
      >
        <ModalOverlay />
        <ModalContent position="relative">
          <ModalHeader>Terms & Conditions</ModalHeader>
          <ModalCloseButton
            position="fixed"
            top="1rem"
            right="1rem"
            zIndex="10"
          />
          <ModalBody overflowY="auto">
            <Text>
              <TermsPage />
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button onClick={closeTermsModal} variant="primary">
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Privacy Policy Modal */}
      <Modal
        isOpen={isPrivacyModalOpen}
        onClose={closePrivacyModal}
        isCentered
        size="xxl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Privacy Policy</ModalHeader>
          <ModalCloseButton
            position="fixed"
            top="1rem"
            right="1rem"
            zIndex="10"
          />
          <ModalBody>
            <Text>
              <PrivacyPage />
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button variant="primary" onClick={closePrivacyModal}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
